module.exports = __webpack_public_path__ + "images/emoji/potable_water.fa3e80e3a8c02c7f84c4.png";